import styled from 'styled-components';
import { UIBottomModal } from '../../../UI';

export const CartFixedButtonAlertModal = styled(UIBottomModal)`
  .alert {
    text-align: center;
    margin-bottom: 20px;
  }
`;
